import { render, staticRenderFns } from "./index.vue?vue&type=template&id=278f258a&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\colocess_web_manage\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('278f258a')) {
      api.createRecord('278f258a', component.options)
    } else {
      api.reload('278f258a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=278f258a&", function () {
      api.rerender('278f258a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/d2-icon/index.vue"
export default component.exports